import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Control, LocalForm } from 'react-redux-form';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import UserTable from './table';
import {Link} from "react-router-dom";
import ModalExample from "./pop";
import { Graphviz } from 'graphviz-react';
import saveSvgAsPng from "save-svg-as-png";
import dsl from "./data.json"

import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import {config} from "../../../utility/swaggerClient";
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import { Container, Row, Col } from 'reactstrap';
import './style.css'
import axios from "axios";

let doc = new jsPDF("l");
// let dsl = {};

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'user.datapipeline',
    description: 'Page Header Title',
    defaultMessage: 'User Management'
  },
  headerSubTitle: {
    id: 'empty.label.name',
    description: 'Page Header Subtitle',
    defaultMessage: ''
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});



class DataPipeline extends Component {
  componentDidMount(){
    // this.props.getusersList(this.props.username);
    console.log(this.props.location.state);
    this.setState({
      companyname: this.props.location.state[0].companyname,
      customer  : this.props.location.state[0].customer,
      dataFactory  : this.props.location.state[0].dataFactory,
      dataFactoryId  : this.props.location.state[0].dataFactoryId,
      prj  : this.props.location.state[0].project,
      app  : this.props.location.state[0].applicationName,
    })


    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json',"Authorization": sessionStorage.getItem('jwt') },
    };
    let that = this;
    let prj =  this.props.location.state[0].project;
    let datafacotry = this.props.location.state[0].dataFactory;
    let customerid = this.props.location.state[0].customer;
    fetch(`${config.protocol}://${config.host}/api/project/getDesignDSL/`+ customerid + '/' + datafacotry + '/' + prj, requestOptions).then((response)=>{
      return response.json();
    }).then((data)=>{
      console.log(data);
      let j = JSON.parse(data.data);
      console.log(j);
      console.log("333");
      this.setState({dsl : j});
      // this.setState({dsl : dsl});
    }).then(()=>{
      this.draw();
      this.setState({afterload: true});
    })
  }

  constructor(props) {
    super(props);
    const { intl } = this.props;
    this.state = {
      showInvite: false,
      showInviteSent: false,
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      role: "",
      delUser: "",
      delEmail: "",
      status: "",
      graph:`graph {}`,
      view: "",
      tables: {},
      steps: {},
      cols: [],
      code: "",
      dsl: dsl,
      afterload: false,
      graphraw: "",
      factory: this.props.location.state[0].dataFactory,
      companyname: this.props.location.state[0].companyname,
      customer  : this.props.location.state[0].customer,
      dataFactoryId  : this.props.location.state[0].dataFactoryId,
      prj  : this.props.location.state[0].project,
      // app  : this.props.location.state[0].applicationName,
    };
  }

  draw = ()=>{
    this.setState({view : "graph"})
    //dot
    let operations=[];
    let stgs={};
    let edges=[];



    let graph_content="";

    let nodebox = "node [shape = box style=filled];";
    let nodeoval="node [shape = oval style=filled];";
    let edge = "";

    if(this.state.dsl == null){
      return;
    }

    this.state.dsl.specObj.Specification.items.forEach((op,opIndex)=>{
      // operations.push(op.name);
      let _op = op['_name'];
      let operration = "xform";
      if(op['filters.rule_expression'][0]["union"].length !== 0){
        operration = "union";
      }else if(op['filters.rule_expression'][0]["join"].length !== 0){
        let agg = op['filters.rule_expression'][0]["aggregation"];
        if( (agg["groupby"] === ""|| !agg.hasOwnProperty("groupby"))
          && (agg["agg"] === ""|| !agg.hasOwnProperty("agg") )
          && (agg["pivot"] === ""|| !agg.hasOwnProperty("pivot") )){
          operration = "join";
        }else{
          operration = "aggregation";
        }
      }
      nodeoval+= _op + '[fillcolor=white label=\"' + _op +': '+ operration +'\"];';

      op['source_database_tables_or_views'].items.forEach((input)=>{
        // tables.push(input.alias);
        if(!stgs.hasOwnProperty(input['_alias'])){
          nodebox += input['_alias'] + '[fillcolor=blue fontcolor=white label=\"'+ input['_schema'] +'.'+ input['_name'] +'\"];';
        }

        edge += input['_alias'] + "->" + _op + ";";
      })

      let _tar = op['target_database_tables_or_views'].items[0];
      if(opIndex === this.state.dsl.specObj.Specification.items.length-1){
        nodebox += _tar['_alias'] + '[fillcolor=blue fontcolor=white label=\"'+ _tar['_schema'] +'.'+ _tar['_name'] +'\"];';
      }else{
        nodebox += _tar['_alias'] + '[fillcolor=white fontcolor=blue label=\"'+ _tar['_schema'] +'.'+ _tar['_name'] +'\"];';
      }
      edge += _op + "->" + _tar['_alias'] + ";";
      stgs[_tar['_alias']] = "";
    });



    graph_content += nodebox;
    graph_content += nodeoval;
    graph_content += edge;

    let graph = 'digraph G {' + 'rankdir="LR";';
    // let graph = 'digraph G {';
    graph +=graph_content
    graph += '}';

    console.log(graph_content)

    this.setState({graph : graph, graphraw: graph_content});
  }

  draw2 = ()=>{
    this.setState({view : "graph"})
    //dot
    let operations=[];
    let stgs={};
    let edges=[];

    // let graph = 'digraph G {' + 'rankdir="LR";';
    let graph = 'digraph G {';

    let nodebox = "node [shape = box style=filled];";
    let nodeoval="node [shape = oval style=filled];";
    let edge = "";



    this.state.dsl.specObj.Specification.items.forEach((op)=>{
      // operations.push(op.name);
      let _op = op['_name'];
      nodeoval+= _op + "[fillcolor=white];";

      op['source_database_tables_or_views'].items.forEach((input)=>{
        // tables.push(input.alias);
        if(!stgs.hasOwnProperty(input['_alias'])){
          nodebox += input['_alias'] + '[fillcolor=blue fontcolor=white];';
        }

        edge += input['_alias'] + "->" + _op + ";";
      })

      let _tar = op['target_database_tables_or_views'].items[0]['_alias'];
      nodebox += _tar + '[fillcolor=white fontcolor=blue];';
      edge += _op + "->" + _tar + ";";
      stgs[_tar] = "";
    });



    graph += nodebox;
    graph += nodeoval;
    graph += edge;


    graph += '}';

    console.log(graph)

    this.setState({graph : graph});
  }

  tablespec = ()=>{
    this.setState({view : "tablespec"});
    let tables = {};
    this.state.dsl.specObj.Specification.items.forEach((op)=>{
      let srcs = op['source_database_tables_or_views'].items;
      let tar = op['target_database_tables_or_views'].items[0];
      if(!tables.hasOwnProperty(tar['_alias'])){
        tables[tar['_alias']] = {};
        let obj = tables[tar['_alias']];
        obj["table"] = tar["_name"];
        obj["db"] = tar["_schema"];
        obj["type"] = "staging";
        if(op['filters.rule_expression'][0]["Output"]["persist"] === "true"){
          obj["persistent"] = "Yes";
        }else{
          obj["persistent"] = "No";
        }
        obj["alias"] = tar['_alias'];
      }
      srcs.forEach((src)=>{
        if(!tables.hasOwnProperty(src['_alias'])){
          tables[src['_alias']] = {};
          let obj = tables[src['_alias']];
          obj["table"] = src["_name"];
          obj["db"] = src["_schema"];
          obj["type"] = "source";
          obj["persistent"] = "Yes";
          obj["alias"] = src['_alias'];
        }
      })

    });
    console.log(tables);
    this.setState({tables:tables});

    const h=[[]];
    const headers =[
      {
        Header: 'Database Name',
        accessor: 'db', // accessor is the "key" in the data
      },
      {
        Header: 'Table Name',
        accessor: 'table',
      },
      {
        Header: 'Persistent',
        accessor: 'persistent', // accessor is the "key" in the data
      },
      {
        Header: 'Table Alias',
        accessor: 'alias', // accessor is the "key" in the data
      }
    ];
    headers.forEach((col)=>{
      h[0].push(col.Header);
    });
    const arr=[];
    Object.keys(tables).forEach((key)=>{
      const rawrow = tables[key];
      const row= [];
      headers.forEach((col)=>{
        row.push(rawrow[col.accessor]);
      })
      arr.push(row);
    })
    console.log(h);
    console.log(arr);
    doc = new jsPDF("l");
    doc.autoTable({
      head: h,
      body: arr,
    })
  }

  tablemapping = ()=>{
    this.setState({view : "tablemapping"});

    let steps = {};

    this.state.dsl.specObj.Specification.items.forEach((op)=>{
      steps[op['_name']]={};
      let obj = steps[op['_name']];
      obj["name"] = op['_name'];
      obj["srctable"] = "";
      obj["output"] = op['target_database_tables_or_views'].items[0]["_alias"];
      obj["jointype"] = "";
      obj["joincondition"] = "";
      obj["filter"] = op['filters.rule_expression'][0]["filter"];
      obj["selectrule"] =  op['filters.rule_expression'][0]["select"];
      if(op['filters.rule_expression'][0]["Output"].hasOwnProperty("mode")){
        obj["mode"] =  op['filters.rule_expression'][0]["Output"]["mode"];
      }
      if(op['filters.rule_expression'][0].hasOwnProperty("orderBy")){
        obj["orderby"] = op['filters.rule_expression'][0]["orderBy"];
      }
      obj["agg"] = op['filters.rule_expression'][0]["aggregation"]["agg"];
      obj["group"] = op['filters.rule_expression'][0]["aggregation"]["groupby"];
      obj["pivot"] = op['filters.rule_expression'][0]["aggregation"]["pivot"];
      if(op['filters.rule_expression'][0]["Output"].hasOwnProperty("SCD2_mode")){
        obj["scd"] = op['filters.rule_expression'][0]["Output"]["SCD2_mode"]["scdkey"];
        obj["effective_date"] = op['filters.rule_expression'][0]["Output"]["SCD2_mode"]["effective_date"];
        obj["end_date"] = op['filters.rule_expression'][0]["Output"]["SCD2_mode"]["end_date"];
        obj["current_ind"] = op['filters.rule_expression'][0]["Output"]["SCD2_mode"]["currind"];
        obj["delete_ind"] = op['filters.rule_expression'][0]["Output"]["SCD2_mode"]["deleteind"];
        obj["hdiff"] = op['filters.rule_expression'][0]["Output"]["SCD2_mode"]["hdiff"];
      }



      if(op['filters.rule_expression'][0]["join"].length > 0){
        op['filters.rule_expression'][0]["join"].forEach((join_obj, join_index)=>{
          if(join_index === 0 ){
            obj["srctable"] += join_obj["from_alias"] + ";";
          }

          if(join_index !== op['filters.rule_expression'][0]["join"].length-1){
            obj["joincondition"] += join_obj["join_condition"] + ";";
            obj["jointype"] += join_obj["join_type"] + ";";
            obj["srctable"] += join_obj["to_alias"] + ";";
          }else{
            obj["joincondition"] += join_obj["join_condition"];
            obj["jointype"] += join_obj["join_type"];
            obj["srctable"] += join_obj["to_alias"];
          }

        })
      }
      else if(op['filters.rule_expression'][0]["union"].length > 0){
        op['filters.rule_expression'][0]["union"].forEach((join_obj, join_index)=>{
          if(join_index === 0 ){
            obj["srctable"] += join_obj["table_alias"] + ";";
          }else{
            if(join_index !== op['filters.rule_expression'][0]["union"].length-1){
              obj["jointype"] += "union;";
              obj["srctable"] += join_obj["table_alias"] + ";";
            }else{
              obj["jointype"] += "union";
              obj["srctable"] += join_obj["table_alias"];
            }
          }
        })
      }
      else {
        obj["srctable"] = op["source_database_tables_or_views"]["items"][0]["_alias"];
      }

    });
    console.log(steps);
    this.setState({steps:steps});

    const h=[[]];
    const headers =[
      {
        Header: 'Step',
        accessor: 'name', // accessor is the "key" in the data
      },
      {
        Header: 'Source Tables',
        accessor: 'srctable',
      },
      {
        Header: 'Output',
        accessor: 'output', // accessor is the "key" in the data
      },
      {
        Header: 'Join Type',
        accessor: 'jointype', // accessor is the "key" in the data
      },
      {
        Header: 'Join Condition',
        accessor: 'joincondition', // accessor is the "key" in the data
      },
      {
        Header: 'Filter',
        accessor: 'filter', // accessor is the "key" in the data
      },
      {
        Header: 'Select Rule',
        accessor: 'selectrule', // accessor is the "key" in the data
      },
      {
        Header: 'Save Mode',
        accessor: 'mode', // accessor is the "key" in the data
      },
      {
        Header: 'Order By',
        accessor: 'orderby', // accessor is the "key" in the data
      },
      {
        Header: 'Aggregation',
        accessor: 'agg', // accessor is the "key" in the data
      },
      {
        Header: 'Group by',
        accessor: 'group', // accessor is the "key" in the data
      },
      {
        Header: 'Pivot',
        accessor: 'pivot', // accessor is the "key" in the data
      },
      {
        Header: 'Scd Key',
        accessor: 'scd', // accessor is the "key" in the data
      },
      {
        Header: 'Effective Date',
        accessor: 'effective_date', // accessor is the "key" in the data
      },
      {
        Header: 'End Date',
        accessor: 'end_date', // accessor is the "key" in the data
      },
      {
        Header: 'Current Ind',
        accessor: 'current_ind', // accessor is the "key" in the data
      },
      {
        Header: 'Delete Ind',
        accessor: 'delete_ind', // accessor is the "key" in the data
      },
      {
        Header: 'Hdiff Name',
        accessor: 'hdiff', // accessor is the "key" in the data
      },
    ];
    headers.forEach((col)=>{
      h[0].push(col.Header);
    });
    const arr=[];
    Object.keys(steps).forEach((key)=>{
      const rawrow = steps[key];
      const row= [];
      headers.forEach((col)=>{
        row.push(rawrow[col.accessor]);
      })
      arr.push(row);
    })
    console.log(h);
    console.log(arr);
    doc = new jsPDF("l");
    doc.autoTable({
      head: h,
      body: arr,
      styles: {fontSize: 2 },
    })
  }

  columnmapping = ()=>{
    this.setState({view : "columnmapping"});

    let cols = [];
    let colObjs ={};
    this.state.dsl.columnObj.Column.items.forEach((col)=>{
      let key = col["_id"];
      colObjs[key] = col;
    })

    // console.log(colObjs);

    this.state.dsl.mappingObj.Mapping.items.forEach((col)=>{
      let obj = {};
      obj["rule_exp"] = col["rule_expression"][0];
      if(col["rule_expression"][0] !== ""){
        console.log(col)
      }

      obj["step"] = col["_context"][0]["_name"];

      let tgt = col["target_columns"]["items"][0];
      let tgt_table = colObjs[tgt["_id"]]["_context"][2]["_name"];
      let tgt_db = colObjs[tgt["_id"]]["_context"][1]["_name"];
      obj["tgt"]= tgt_db + "." + tgt_table + "." + tgt["_name"];
      obj["src"]= "";
      if(col["source_columns"]["items"].length >0){
        let src = col["source_columns"]["items"][0];
        if(!src.hasOwnProperty("_id")){
          console.log(src)
          console.log(col)
          obj["src"]= "derived";
        }else{
          let src_table = colObjs[src["_id"]]["_context"][2]["_name"];
          let src_db = colObjs[src["_id"]]["_context"][1]["_name"];
          obj["src"]= src_db + "." + src_table + "." + src["_name"];
        }
      }


      cols.push(obj);
    })

    console.log(cols);
    this.setState({cols:cols});

    const h=[[]];
    const headers =[
      {
        Header: 'Source',
        accessor: 'src', // accessor is the "key" in the data
      },
      {
        Header: 'Target',
        accessor: 'tgt',
      },
      {
        Header: 'Rule Expression',
        accessor: 'rule_exp', // accessor is the "key" in the data
      },
      {
        Header: 'Step',
        accessor: 'step', // accessor is the "key" in the data
      }
    ];
    headers.forEach((col)=>{
      h[0].push(col.Header);
    });
    const arr=[];
    cols.forEach((col)=>{
      const row= [];
      headers.forEach((header)=>{
        row.push(col[header.accessor]);
      })
      arr.push(row);
    })
    console.log(h);
    console.log(arr);
    doc = new jsPDF("l");
    doc.autoTable({
      head: h,
      body: arr,
    })
  }

  donwloadpipeline = ()=>{
    // saveSvgAsPng.saveSvgAsPng(document.getElementById('graph-body').getElementsByTagName("svg")[0], "diagram.png");
    if(this.state.view === "graph"){
      // saveSvgAsPng.saveSvgAsPng(document.getElementById('graph-body').getElementsByTagName("svg")[0], "diagram.png");

      let body = this.state.graphraw;
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',"Authorization": sessionStorage.getItem('jwt') },
        body
      };
      let that = this;
      fetch(`${config.protocol}://${config.host}/api/user/downloaddiagram`, requestOptions)
        .then(response =>
          {
            console.log(response)
            return response.blob()
          })
            .then(data => {
              const FileDownload = require("js-file-download");
              FileDownload(data, "graph.pdf");
            }).catch(err => console.log(err));

        }else{
          doc.save('table.pdf')
        }
  }

  donwloadzip = ()=>{
    axios
      .get(
        `${config.protocol}://${config.host}/api/project/getgroupnamebydatafactoryid/${
          this.state.dataFactoryId
        }`
      )
      .then(res => {
        let groupName = res.data;

        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json',"Authorization": sessionStorage.getItem('jwt') },
        };
        let that = this;
        let prj =  this.props.location.state[0].project;
        let datafacotry = this.props.location.state[0].dataFactory;
        let customerid = this.props.location.state[0].customer;

        fetch(`${config.STMhost}/v1/designdocs/genbytesresource/` + groupName + '/' + datafacotry + '/' + prj , requestOptions)
          .then(response =>
          {
            console.log(response)
            return response.blob()
          })
          .then(data => {
            const FileDownload = require("js-file-download");
            FileDownload(data, "code.zip");
          }).catch(err => console.log(err));
      });





  }

  invitedsent = ()=>{
    this.setState({showInviteSent : true});
    messages.headerTitle = {
      id: 'user.invitation',
      description: 'Page Header Title',
      defaultMessage: 'Success'
    };
  }

  selectItem = (value)=>{
    console.log(value);
    this.setState({delUser: value.username,status: value.status,delEmail: value.email})
  }
  openModal = ()=>{};

  confirmationText = "Your Admin user has been changed successfully. Please log In with the credential for new admin user."


  render() {
    return (
      <div className="preview page">
        <Helmet>
          <title>
            {this.props.intl.formatMessage(messages.htmlHeader)} - FUSE
          </title>
        </Helmet>
        <Header
          title={this.props.intl.formatMessage(messages.headerTitle)}
          subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
          icon="preview"
          locale={this.props.locale}
          status = {this.props.status}
        />
        <ModalExample
          hasTitle
          warning
          className="modal_sm"
          reset={()=>this.props.logout()}
          setClick={click => this.openModal = click}
          content={this.confirmationText}/>


        <div className="main">
          {this.state.afterload &&(
            <div
              className="panel"
              style={{
                width: '90%',
                padding: '40px',
                boxSizing: 'content-box',
                marginTop: '15px',
                display: 'block',
                alignContent: 'center',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}
            >
              <LocalForm
                className="form"
                model="user"
                // onSubmit={this.sendInvite}
              >
                <Row>
                  <Col xs="4" >
                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Data Factory Name
                      </label>
                      <Control.text
                        model="user.factory"
                        value={this.state.factory}
                        disabled
                      />
                    </fieldset>
                  </Col>
                  <Col xs="4" >
                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Project Name
                      </label>
                      <Control.text
                        model="user.prj"
                        value={this.state.prj}
                        disabled
                      />
                    </fieldset>
                  </Col>
                  <Col xs="4" >
                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Application Name
                      </label>
                      <Control.text
                        model="user.app"
                        value={this.props.location.state[0].applicationName}
                        disabled
                      />
                    </fieldset>
                  </Col>
                </Row>
                <div>
                  <button
                    className="button"
                    onClick={()=>{this.draw()} }
                    style={{ opacity : this.state.view === "graph" ? "0.5" : "1" }}
                  >
                    Graphic View
                  </button>
                  <button
                    className="button"
                    style={{  opacity : this.state.view === "tablespec" ? "0.5" : "1" }}
                    onClick={()=>{this.tablespec()}}
                  >
                    Table Specification
                  </button>
                  <button
                    className="button"
                    style={{  opacity : this.state.view === "tablemapping" ? "0.5" : "1" }}
                    onClick={()=>{this.tablemapping()}}
                  >
                    Table Mapping Specification
                  </button>
                  <button
                    className="button"
                    style={{  opacity : this.state.view === "columnmapping" ? "0.5" : "1" }}
                    onClick={()=>{this.columnmapping()}}
                  >
                    Column Mappings
                  </button>
                  <div>
                    { this.state.view === "graph" && (
                      <div id="graph-body" style={{overflow: "auto", margin: "30px"}}>
                        <Graphviz dot={this.state.graph}
                                  options={{"zoom" : true,height: 300,width: 1000}}
                        />
                      </div>
                    )}
                    { this.state.view === "tablespec" && (
                      <UserTable data={this.state.tables} type="tablespec" tableid="tablespec"/>
                    )}
                    { this.state.view === "tablemapping" && (
                      <UserTable data={this.state.steps} type="tablemapping" tableid="tablemapping"/>
                    )}
                    { this.state.view === "columnmapping" && (
                      <UserTable data={this.state.cols} type="columnmapping" tableid="columnmapping"/>
                    )}


                  </div>


                </div>

                <div className="button-container" style={{ textAlign: 'center' }}>
                    <Link to={{
                      pathname: '/en-CA/projectmanagement/' + this.props.location.state[0].dataFactory + '/' + this.props.location.state[0].dataFactoryId,
                      state:[{
                        dataFactory : this.state.dataFactory,
                        dataFactoryId : this.state.dataFactoryId,
                        companyname : this.state.companyname,
                        customer : this.state.customer,
                        project: this.state.prj
                      }]
                    }}>
                    <button
                      className="button"
                      style={{ marginRight: '40px' }}
                    >
                      <FormattedMessage
                        id="run-assessment.back.button.name"
                        textTransform="capitalize"
                        defaultMessage="Back"
                      />
                    </button>
                  </Link>


                  <button
                    className="button"
                    style={{ marginRight: '40px' }}
                    onClick={()=>{this.donwloadpipeline()} }
                  >
                    PRINT
                  </button>

                  <button
                    className="button"
                    onClick={()=>{this.donwloadzip()} }
                  >
                    DOWNLOAD
                  </button>
                </div>
              </LocalForm>


            </div>
          )}

        </div>


        <Footer />
      </div>
    );
  }
}

DataPipeline.propTypes = {
  username: PropTypes.string,
  usersList: PropTypes.array
};

export default injectIntl(DataPipeline);



// WEBPACK FOOTER //
// ./src/components/views/DataPipeline/index.js